import React from 'react';
import './NotFound.css';

const NotFound = () => {
    return (
        <div className="notfound-container">
            <img src="https://i.ibb.co/RBxynzf/notfound.png" className="img-fluid w-50" alt="" />
        </div>
    );
};

export default NotFound;